// extracted by mini-css-extract-plugin
export default {"base":"ArrowButton_base__wFsS-","left":"ArrowButton_left__snHtu","disabled":"ArrowButton_disabled__aQoBn"};